import { Component, Input, OnDestroy } from '@angular/core';
import { ErweiterungConfigResponse } from '../../../../core/base-api';
import { TranslatePipe } from '@ngx-translate/core';
import { HistoryDirective } from '../../../../shared/directives/history.directive';
import { KompaktTimepointComponent } from '../../../../shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { NgTemplateOutlet } from '@angular/common';
import { FormatBeEdidPipe } from '../../../../shared/pipes/format/format-be-edid.pipe';
import { FormatEdidPipe } from '../../../../shared/pipes/format/format-edid.pipe';
import { KompaktVersionGebaeudeeingangsadressePipe } from '../../../../shared/kompaktdarstellung/gebaeudeeingangsadresse/kompakt-version-gebaeudeeingangsadresse-pipe';
import { OrderByEingangadressePipe } from '../../../../shared/pipes/order/order-by-eingangadresse.pipe';
import { FormatConfigService } from '../../../../core/services/format-config.service';
import { keysToTranslate } from '../../../../../i18n/keys-to-translate';
import { GebaeudeEingangAdresseMasterDetailEntryMeta, GebaeudeEingangAdresseVersionDetailEntryMeta } from '../../../../core/av-api';
import { Subscription } from 'rxjs';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

@Component({
  selector: 'cap-gebaeude-eingangsadressen',
  templateUrl: './gebaeude-eingangsadressen.component.html',
  styleUrls: ['./gebaeude-eingangsadressen.component.scss'],
  imports: [
    TranslatePipe,
    HistoryDirective,
    KompaktTimepointComponent,
    NgTemplateOutlet,
    FormatBeEdidPipe,
    FormatEdidPipe,
    KompaktVersionGebaeudeeingangsadressePipe,
    OrderByEingangadressePipe
  ]
})
export class GebaeudeEingangsadressenComponent implements OnDestroy {
  eingangAdressenVM: Array<EingangAdresseMasterVM>;

  showKantDid: boolean;
  avPlusErweiterung: boolean;
  private subscription: Subscription = new Subscription();

  constructor(private appFormatConfigService: FormatConfigService) {
    keysToTranslate<string>(['Gebaeudebezeichnung', 'Strasse', 'StrasseBenanntesGebiet', 'Haus-Nr.', 'EDID', 'BE-EDID', 'gebaeudeart']);
    this.subscription.add(
      this.appFormatConfigService.erweiterungsConfig$.subscribe((config) => {
        this.avPlusErweiterung = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.AV_PLUS);
      })
    );
  }

  @Input()
  set eingangAdressen(value: Array<GebaeudeEingangAdresseMasterDetailEntryMeta>) {
    if (!value) {
      return;
    }
    if (value[0]) {
      this.showKantDid = value[0].mKantDid.access !== 'DEACTIVATED';
    }
    this.createViewModel(value);
  }

  createViewModel(adressen: GebaeudeEingangAdresseMasterDetailEntryMeta[]) {
    this.eingangAdressenVM = [];
    for (const adresse of adressen) {
      const versions = adresse.versions;
      adresse.versions = null;
      if (versions) {
        for (let i = 0; i < versions.length; i++) {
          const viewObject = <EingangAdresseMasterVM>adresse;
          const value = versions[i];
          viewObject.version = value;
          this.eingangAdressenVM.push({ ...viewObject });
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}

export interface EingangAdresseMasterVM extends GebaeudeEingangAdresseMasterDetailEntryMeta {
  version: GebaeudeEingangAdresseVersionDetailEntryMeta;
}
